<template>
  <div class="page-container">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>{{ $t('common.settings') }}</span>
        </div>
      </template>

      <div class="settings-content">
      <el-tabs v-model="activeTab" class="settings-tabs">

        <el-tab-pane :label="$t('settings.displaySettings')" name="display">
          <DisplaySettings />
        </el-tab-pane>

        <el-tab-pane :label="$t('settings.profile')" name="profile">
          <ProfileSettings />
        </el-tab-pane>

        <el-tab-pane :label="$t('settings.bookingPolicy')" name="bookingPolicy">
          <BookingPolicy />
        </el-tab-pane>

        <el-tab-pane :label="$t('settings.clubInfo')" name="club">
          <ClubInfo />
        </el-tab-pane>

        <el-tab-pane :label="$t('settings.about.title')" name="about">
          <AboutSettings />
        </el-tab-pane>
      </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import ClubInfo from './components/ClubInfo.vue'
import ProfileSettings from './components/ProfileSettings.vue'
import DisplaySettings from './components/DisplaySettings.vue'
import BookingPolicy from './components/BookingPolicy.vue'
import AboutSettings from './components/AboutSettings.vue'

const activeTab = ref('display')
</script>

<style scoped lang="scss">
.page-container {
  padding: 12px;
  background-color: var(--bg-color-page, #f5f7fa);
  min-height: 100vh;
  transition: background-color 0.3s ease;
  
  @media (max-width: 768px) {
    padding: 8px;
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  
  @media (max-width: 768px) {
    padding: 4px 0;
  }
}

.card-header span {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary, #303133);
  transition: color 0.3s ease;
  
  @media (max-width: 768px) {
    font-size: 15px;
  }
}

.settings-content {
  flex: 1;
  overflow-y: auto;
  background: var(--bg-color-white, #fff);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: background-color 0.3s ease;
  
  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 6px;
  }
  
  html.dark & {
    background: var(--bg-color-white, #2d3748);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  }
}

:deep(.settings-tabs) {
  .el-tabs__header {
    margin-bottom: 20px;
    
    @media (max-width: 768px) {
      margin-bottom: 16px;
    }
  }
  
  .el-tabs__item {
    color: var(--color-text-regular, #606266);
    
    html.dark & {
      color: var(--color-text-regular, #e2e8f0);
      
      &.is-active {
        color: var(--el-color-primary, #409eff);
      }
      
      &:hover {
        color: var(--el-color-primary, #409eff);
      }
    }
    
    @media (max-width: 768px) {
      padding: 0 12px;
      font-size: 13px;
    }
  }
  
  .el-tabs__active-bar {
    html.dark & {
      background-color: var(--el-color-primary, #409eff);
    }
  }
  
  .el-tabs__nav-wrap::after {
    background-color: var(--border-color-light, #e4e7ed);
    
    html.dark & {
      background-color: var(--border-color-light, #4a5568);
    }
  }
}
</style>
